'use strict';

var keys = require('./keys.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Maps over the properties of an object and returns a new object with the mapped values.

 */ function mapObject(x, cb, filter) {
    return keys(x).reduce((results, key, i)=>{
        const result = cb(x[key], key, i);
        if (!filter || filter(result)) return _extends({}, results, {
            [key]: result
        });
        return results;
    }, {});
}

module.exports = mapObject;
